export const REPORT_STATE_SELECTOR = "reportGeoAffiliatesDetails";
export const REPORT_COLUMNS_KEY =
  "[REPORT ==> affiliates_geo_detail] Visible columns is:";
export const REPORT_DATE_KEY =
  "[REPORT ==> affiliates_geo_detail] Date range is: ";
